import { handleJavaScriptError } from './handlers/javascriptErrorHandler';
import { handlePromiseRejection } from './handlers/promiseRejectionHandler';
import { handleResourceError } from './handlers/resourceErrorHandler';
import { overrideConsoleError } from './handlers/consoleErrorHandler';
import { getViewContext } from './utils/viewContext';
import { ErrorContext } from './types/errorTypes';

class GlobalErrorHandler {
  private isInitialized = false;

  public initialize(): void {
    if (this.isInitialized) {
      console.log('⚠️ Global error handlers already initialized');
      return;
    }

    // Handle unhandled JavaScript errors
    window.addEventListener('error', (event) => 
      handleJavaScriptError(event, getViewContext)
    );

    // Handle unhandled promise rejections
    window.addEventListener('unhandledrejection', (event) => 
      handlePromiseRejection(event, getViewContext)
    );

    // Handle resource loading errors
    window.addEventListener('error', handleResourceError, true);

    // Handle console errors (in development)
    if (process.env.NODE_ENV === 'development') {
      overrideConsoleError();
      console.log('✅ Registered console.error override (development mode)');
    }

    this.isInitialized = true;
    console.log('✅ Global error handlers initialized successfully');
  }
}

export const globalErrorHandler = new GlobalErrorHandler();
export type { ErrorContext };